// extracted by mini-css-extract-plugin
export var angle = "externalArticle-module--angle--96a6a";
export var divider = "externalArticle-module--divider--1df1c";
export var externalArticle = "externalArticle-module--externalArticle--4240b";
export var externalArticleContainer = "externalArticle-module--externalArticleContainer--637f2";
export var externalArticleWrapper = "externalArticle-module--externalArticleWrapper--362e0";
export var headline = "externalArticle-module--headline--912f4";
export var slideUp = "externalArticle-module--slideUp--81b18";
export var slideUpLarge = "externalArticle-module--slideUpLarge--caa70";
export var title = "externalArticle-module--title--1b20e";